import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { MapPin, ArrowRight } from 'lucide-react';
import SEO from '@/components/dubinko/SEO';
import { AREAS } from '@/constants/testIds';

export default function AreasIndexPage() {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/areas').then(({ data }) => setAreas(data)).finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid={AREAS.index}>
      <SEO
        title="Područja koja pokrivamo u Nišu"
        description="Dubinko pokriva čitav Niš — Niš centar, Medijana, Palilula, Crveni Krst, Pantelej, Niška Banja. Profesionalno dubinsko čišćenje na vašoj adresi."
        path="/podrucja"
      />
      <section className="section-pad aurora-bg grain">
        <div className="container-x">
          <span className="tag-pill">Područja</span>
          <h1 className="font-display text-5xl md:text-6xl font-extrabold mt-4 max-w-3xl">
            Dolazimo na vašu adresu u Nišu
          </h1>
          <p className="text-slate-600 mt-4 text-lg max-w-2xl">
            Pokrivamo sva naselja u Nišu i okolini. Izaberite svoje područje i saznajte detalje.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          {loading ? (
            <div className="text-slate-500">Učitavanje…</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {areas.map((a) => (
                <Link key={a.id} to={`/podrucja/${a.slug}`} data-testid={AREAS.card}
                  className="service-card group">
                  <div className="ribbon" />
                  <div className="icon-wrap bg-emerald-50 text-emerald-700">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <h2 className="font-display text-2xl font-bold mt-4">{a.name}</h2>
                  <p className="text-slate-600 mt-2">{a.description}</p>
                  <div className="mt-5 inline-flex items-center gap-2 font-semibold text-blue-700 group-hover:gap-3 transition-all">
                    Saznajte više <ArrowRight className="w-4 h-4" />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
